var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var LOCAL_STORAGE_VERSION = 'LOCAL_STORAGE_VERSION';
export default (function (config) {
    var versionInBrowser = localStorage.getItem(LOCAL_STORAGE_VERSION) || 'DEFAULT';
    if (config.version !== versionInBrowser) {
        if (config.migrations) {
            var currentIndex = config.migrations.map(function (_a) {
                var _b = __read(_a, 1), version = _b[0];
                return version;
            }).indexOf(versionInBrowser);
            var missingMigrations = config.migrations.slice(currentIndex === -1 ? 0 : currentIndex + 1);
            missingMigrations.forEach(function (_a) {
                var _b = __read(_a, 2), keys = _b[1];
                var migrationKeys = Object.keys(keys);
                migrationKeys.forEach(function (key) { return localStorage.setItem(key, keys[key](localStorage.getItem(key))); });
            });
        }
        if (config.remove) {
            config.remove.forEach(function (key) {
                localStorage.removeItem(key);
            });
        }
        if (config.removeAll) {
            localStorage.clear();
        }
        localStorage.setItem(LOCAL_STORAGE_VERSION, config.version);
    }
});
